import React from 'react';
import ReactDOM from 'react-dom/client';
import { ExpertPlatformSubmitQuestionPage } from './ExpertPlatformSubmitQuestionPage';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ExpertPlatformSubmitQuestionPage />
  </React.StrictMode>
);
